import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { useAuth } from '../../hooks/useAuth'

import { SECTIONS, ADMIN_SECTIONS } from './helpSections'

export default function HelpTOC({ currentSection }) {
  const { t } = useTranslation()
  const { user } = useAuth()

  const sections = user?.role === 'super_user'
    ? [...SECTIONS, ...ADMIN_SECTIONS]
    : SECTIONS

  return (
    <nav aria-label={t('help.toc.title')} className="md:sticky md:top-20">
      <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-3">
        {t('help.toc.title')}
      </h2>
      <ul className="space-y-1">
        {sections.map((s) => {
          const active = currentSection === s.slug
          return (
            <li key={s.slug}>
              <Link
                to={`/help/${s.slug}`}
                aria-current={active ? 'page' : undefined}
                data-testid={`help-toc-${s.slug}`}
                className={clsx(
                  'block px-3 py-2 rounded-md text-sm border-l-4',
                  active
                    ? 'bg-primary-50 border-primary-500 text-primary-700 font-medium'
                    : 'border-transparent text-gray-700 hover:bg-gray-50 hover:text-gray-900',
                )}
              >
                {t(s.i18nKey)}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
